function Second(config, renderer, calculatorImpl) {
  const self = this

  const calculator = calculatorImpl || new Calculator2021(CalculatorConfiguration, fundShares)
  let params, recommendations

  $.extend(self, this, new Details(renderer))

  self.init = function () {
    const activeFund = session.pension.secondPillar.activeFunds[0]
    const recommendation = Recommendations.secondPillar[session.pension.ageGroup]

    const funds = activeFund ? [
      {percent: 100, donut: new MiniDonut().params(activeFund.percentage), fund: activeFund.fund}
    ] : []
    const currentFund = activeFund ? activeFund.fund : {}
    const current = {
      funds: funds,
      shortDescription: this.strategyDescription(this.id(funds)),
      strategy: Labels['pension-risk-' + currentFund.risk],
      id: this.id(funds)
    }

    recommendations = [
      [{fund: recommendation[0], percent: 100}],
      [{fund: recommendation[1], percent: 100}],
      [{fund: recommendation[2], percent: 100}]
    ]

    const estimation = calculator.calculate(session.pension, session.pension.thirdPillar.averageMonthlyContribution)
    const alternatives = this.createAlternatives(recommendations, current)
    params = {
      pension: session.pension.secondPillar,
      current: current,
      alternatives: alternatives,
      recommendationDescriptions: this.recommendationDescriptions(alternatives, current),
      estimation: {
        amount: estimation.secondPillar.monthlyAmount,
        ratio: new Ratios(estimation.firstPillar.monthlyAmount, estimation.secondPillar.monthlyAmount, estimation.thirdPillar.monthlyAmount).calculate().secondPillar
      },
      lines: this.lines(alternatives, current)
    }
    return params
  }

  self.done = function () {
    this.initializeChart(params)
    $("input[type=radio][name=pillar-selection]").change(function () {
      self.selectFund(this.value, params.current.id)
//      ViewHelper.scrollElementToTop("#strategy-details")
    })
    $('#CTA').find('.alternative').find('a').click(function () {
      location.href = '#second-pillar-select?isin=' + $('input[name="pillar-selection"]:checked').val()
      return false
    })
    this.strategyLink()
  }

  self.strategyDescription = function (strategyId) {
    const description = Labels['pension-strategy-shortDescription-' + strategyId]
    return description ? description : Labels['pension-secondPillar-otherActiveFund']
  }

  self.strategyPill = function (funds) {
    return Labels['pension-risk-' + funds[0].fund.risk]
  }

  self.id = function (assets) {
    return assets.length ? assets[0].fund.isin : ''
  }

  self.strategyName = function (strategy) {
    return strategy.funds.length ? strategy.funds[0].fund.name : ''
  }
}